(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-brand-value"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-brand-value-script')
    if (!window.brandValues && $url && $url.dataset.designMode !== 'yes') {
      window.brandValues = $url.value

      var $script = document.createElement('script')
      $script.src = window.brandValues
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["advertorial-product-form"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cards-scroller"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-cards-scroller-script')
    if (!window.cardsScroller && $url && $url.dataset.designMode !== 'yes') {
      window.cardsScroller = $url.value

      var $script = document.createElement('script')
      $script.src = window.cardsScroller
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-grid-script')
    if (!window.featuredGrids && $url && $url.dataset.designMode !== 'yes') {
      window.featuredGrids = $url.value

      var $script = document.createElement('script')
      $script.src = window.featuredGrids
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finishes-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-finishes-gallery-script')
    if (!window._finishesGallery && $url && $url.dataset.designMode !== 'yes') {
      window._finishesGallery = $url.value
      var $script = document.createElement('script')
      $script.src = window._finishesGallery
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["highlight-cards"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-highlight-cards-script')
    if (!window.highlightCards && $url && $url.dataset.designMode !== 'yes') {
      window.highlightCards = $url.value

      var $script = document.createElement('script')
      $script.src = window.highlightCards
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-image-cards-script')
  if (!window.imageCards && $url && $url.dataset.designMode !== 'yes') {
    window.imageCards = $url.value

    var $script = document.createElement('script')
    $script.src = window.imageCards
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-sliders"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-sliders-script')
    if (!window.imageSliders && $url && $url.dataset.designMode !== 'yes') {
      window.imageSliders = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageSliders
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-tab"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-tab-script')
    if (!window.imageTab && $url && $url.dataset.designMode !== 'yes') {
      window.imageTab = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTab
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-switch"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-image-text-switch-script')
    if (!window.imageTextSwitch && $url && $url.dataset.designMode !== 'yes') {
      window.imageTextSwitch = $url.value

      var $script = document.createElement('script')
      $script.src = window.imageTextSwitch
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpNeos-main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpNeos-product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpT04-main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lpT04-product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v2-script')
    if (!window.productV2 && $url && $url.dataset.designMode !== 'yes') {
      window.productV2 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV2
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-main-product-v1-script')
    if (!window.productV1 && $url && $url.dataset.designMode !== 'yes') {
      window.productV1 = $url.value
      var $script = document.createElement('script')
      $script.src = window.productV1
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-media-reviews-script')
    if (!window._loadMediaReviews && $url && $url.dataset.designMode !== 'yes') {
      window._loadMediaReviews = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadMediaReviews
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milestone"] && !Shopify.designMode) return;
  try {
    
(function() {
  var $url = document.querySelector('.as-milestone-script')
  if (!window._milestone && $url && $url.dataset.designMode !== 'yes') {
    window._milestone = $url.value

    var $script = document.createElement('script')
    $script.src = window._milestone
    $script.defer = "defer"
    document.body.appendChild($script)
  }
})()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neos-ll-pdp-card-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var $url = document.querySelector('.as-neos-ll-pdp-script');
    if (!window._neosllPdp && $url) {
      window._neosllPdp = $url.value;
      var $script = document.createElement('script');
      $script.src = window._neosllPdp;
      $script.defer = 'defer';
      document.body.appendChild($script);
    }
    let waitSwiperJs = (callback, flag, loopCount)=>{
      loopCount = loopCount || 0;
      if(!flag) {
        console.log("Try to locate `Swiper`...");
      } else {
        console.log("Retry to locate `Swiper`...");
      }
      if(!window.Swiper) {
        if(loopCount > 100) {
          if(window.tick_20250430155855) { clearTimeout(window.tick_20250430155855); }
          console.log("Failed to locate `Swiper`...");
          return;
        }
        if(window.tick_20250430155855) { clearTimeout(window.tick_20250430155855); }
        window.tick_20250430155855 = setTimeout(()=>{
          waitSwiperJs(callback, true, loopCount + 1);
        }, 100);
      } else {
        console.log("Locate `Swiper` successfully.");
        callback.call();
      }
    };
    let loadSwiper = () => {
      if(!window.Swiper) return;
      let swiper = new Swiper(".nlpcv-swiper-container", {
        /*centeredSlides: true,*/
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
        /*navigation: {
          nextEl: ".nlpcv-swiper-button-next",
          prevEl: ".nlpcv-swiper-button-prev",
        },*/
        on: {
          slideChange: function() {
            /*
            if(document.querySelector(".neos-ll-pdp-container.infomation-container")) {
              if(this.realIndex == 0) {
                document.querySelector(".neos-ll-pdp-container.infomation-container").classList.remove("d-none");
              } else {
                document.querySelector(".neos-ll-pdp-container.infomation-container").classList.add("d-none");
              }
            }
            */
          }
        }
      });
    };
    document.addEventListener('DOMContentLoaded', ()=>{waitSwiperJs(loadSwiper);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-featured-product-script')
    if (!window.featuredProduct && $url && $url.dataset.designMode !== 'yes') {
      window.featuredProduct = $url.value
      var $script = document.createElement('script')
      $script.src = window.featuredProduct
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["referral"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-referral-script')
    if (!window.brandValues && $url && $url.dataset.designMode !== 'yes') {
      window.brandValues = $url.value

      var $script = document.createElement('script')
      $script.src = window.brandValues
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stairs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-stairs-script')
    if (!window._stairs && $url && $url.dataset.designMode !== 'yes') {
      window._stairs = $url.value

      var $script = document.createElement('script')
      $script.src = window._stairs
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-subscribe-banner-script')
    if (!window.subscribeBanner && $url && $url.dataset.designMode !== 'yes') {
      window.subscribeBanner = $url.value

      var $script = document.createElement('script')
      $script.src = window.subscribeBanner
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var $url = document.querySelector('.as-testimonials-script')
    if (!window._loadSwiper && $url && $url.dataset.designMode !== 'yes') {
      window._loadSwiper = $url.value

      var $script = document.createElement('script')
      $script.src = window._loadSwiper
      $script.defer = "defer"
      document.body.appendChild($script)
    }
  })()

  } catch(e) { console.error(e); }
})();
})();
